import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22 5C22.5523 5 23 4.55229 23 4C23 3.44772 22.5523 3 22 3L2 3C1.44772 3 1 3.44771 1 4C1 4.55228 1.44772 5 2 5L22 5Z M12 12.4142L21.2929 21.7071C21.6834 22.0976 22.3166 22.0976 22.7071 21.7071C23.0976 21.3166 23.0976 20.6834 22.7071 20.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L1.29289 20.2929C0.902369 20.6834 0.902369 21.3166 1.29289 21.7071C1.68342 22.0976 2.31658 22.0976 2.70711 21.7071L12 12.4142Z"
  }));
});
var NavigationChevronTop = AbstractIcon.withComponent(Icon);
NavigationChevronTop.displayName = 'NavigationChevronTop';
export default NavigationChevronTop;